import React from 'react';
import { Box, Container, Typography } from '@mui/material';

const WhoWereBuiltForSection = () => {
    return (
        <Box
            component="section"
            id="solution"
            aria-labelledby="solution-section-heading"
            sx={{
                position: 'relative',
                py: { xs: 7, md: 6.5, lg: 6.5 },
                background: 'linear-gradient(180deg, #FAFBFF 0%, #FFFFFF 40%, #F5F8FF 100%)',
                borderTop: '1px solid rgba(0, 102, 255, 0.06)',
                borderBottom: '1px solid rgba(0, 102, 255, 0.06)',
                overflow: 'hidden',
                '&::before': {
                    content: '""',
                    position: 'absolute',
                    top: 0,
                    left: '50%',
                    transform: 'translateX(-50%)',
                    width: 'min(100%, 960px)',
                    height: '280px',
                    background:
                        'radial-gradient(ellipse 70% 55% at 50% 0%, rgba(0, 102, 255, 0.06) 0%, transparent 70%)',
                    pointerEvents: 'none',
                },
            }}
        >
            <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 1 }}>
                <Box sx={{ textAlign: 'center', maxWidth: 720, mx: 'auto'}}>    
                    <Typography
                        component="span"
                        sx={{
                            display: 'inline-block',
                            fontSize: { xs: '0.6875rem', sm: '0.75rem' },
                            fontWeight: 700,
                            letterSpacing: '0.18em',
                            textTransform: 'uppercase',
                            color: '#0066FF',
                            bgcolor: 'rgba(0, 102, 255, 0.1)',
                            px: { xs: 1.75, sm: 2.25 },
                            py: 0.75,
                            borderRadius: 999,
                            mb: 2.5,
                        }}
                    >
                        WHO WE'RE BUILT FOR
                    </Typography>
                </Box>
                <Typography
                    id="solution-section-heading"
                    variant="h2"
                    sx={{
                        fontSize: { xs: '1.75rem', sm: '2.125rem', md: '2.5rem', lg: '2.75rem' },
                        fontWeight: 700,
                        lineHeight: 1.22,
                        letterSpacing: '-0.03em',
                        textAlign: 'center',
                        color: '#0F172A',
                        mb: { xs: 3, md: 3.25 },
                        // maxWidth: '22ch',
                    }}
                >
                    Built for one workflow. Not adapted for it
                </Typography>

                <Typography
                    component="p"
                    sx={{
                        fontSize: { xs: '1rem', sm: '1.0625rem', md: '1.125rem' },
                        lineHeight: 1.75,
                        color: 'rgba(15, 23, 42, 0.82)',
                        fontWeight: 400,
                        // maxWidth: '42rem',
                        textAlign: 'justify',
                        mb: 2,
                    }}
                >
                    If you run a rehabilitation centre with field-deployed therapy teams (physio, neuro, ortho, stroke, speech & swallow, geriatric, sports & musculoskeletal and others) running home visits alongside in-house sessions, this was built for you. 
                    Typically 5 to 50 therapists. Operations on informal systems that are not keeping up.
                </Typography>

                <Typography
                    component="p"
                    sx={{
                        fontSize: { xs: '1rem', sm: '1.0625rem', md: '1.125rem' },
                        lineHeight: 1.75,
                        color: 'rgba(15, 23, 42, 0.82)',
                        fontWeight: 400,
                        // maxWidth: '42rem',
                        textAlign: 'justify',
                        mb: 0,
                    }}
                >
                    Solo practitioners managing home visits without an organisational setup face the same problem personally.
                    They're on the platform and actively supported.
                </Typography>
            </Container>
        </Box>
    );
};

export default WhoWereBuiltForSection;

